module.exports = __webpack_public_path__ + "img/Flag_of_the_United_Arab_Emirates.8ae6708c.svg";